import React, { useState, useEffect } from 'react';
import moment from "moment";
import { TimePicker } from 'antd';

interface props {
  onChange?: any,
  value?: any,
  style?: any,
  startName?: any,
  endName?: any,
  disabledDate?: any,
}

const SPTimeRangePicker: React.FC<props> = (props) => {
  const { onChange, value, style, startName, endName, disabledDate } = props

  const format = 'HH:mm';

  const getDefaultValue: any = (dates: any) => {
    if(!dates) return [undefined, undefined];

    let start: any = dates[startName],
        end: any = dates[endName];

    if(moment(start, format).isValid() && moment(end, format).isValid()){
        return [moment(start, format), moment(end, format)];
    }else{
        return [undefined, undefined]
    }

  };

  const onMoment = (dates: any, dateStrings: any) => {
    // let val: any = {};

    if(!dateStrings) return onChange({});

    // if(moment(dates[0], format).isValid() && moment(dates[1], format).isValid()){
    //     val[startName] = moment(dates[0], format);
    //     val[endName] = moment(dates[1], format);
    // }else{
    //     return onChange(val);
    // }

    onChange({
      [startName]: dateStrings[0],
      [endName]: dateStrings[1]
    });
  };

  return (
    <TimePicker.RangePicker style={style} defaultValue={getDefaultValue(value)} onChange={onMoment} disabledDate={disabledDate} format={format}/>
  );
};

export default SPTimeRangePicker;

